import {
  type Channel,
  type ContactType,
  channelSchema,
  ContactTypeSchema,
} from '../schemas'

const send = (ev: any) => {
  window.hj =
    window.hj ||
    function (args: any) {
      ;(window.hj.q = window.hj.q || []).push(args)
    }
  window.hj('event', ev)
}

const sendCottageContact = () => {
  const email: Channel = channelSchema.Values.EMAIL
  const contact: ContactType = ContactTypeSchema.Values.CONTACT

  send(`${email}-${contact}`)
}
export { send, sendCottageContact }
